import { createSelector } from '@ngrx/store';

import { ParameterResult } from '@models/swagger';
import { State } from './reducer';
import { selectHomeUseState } from '../selectors';

export const getData = createSelector(selectHomeUseState, (state: State) => state.data);

export const getError = createSelector(selectHomeUseState, (state: State) => state.error);

export const getLoading = createSelector(selectHomeUseState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: ParameterResult) => T) =>
  createSelector(selectHomeUseState, (state: State) => fn(state.data));
